import { useLang } from '../i18n/context';

export default function Marquee() {
    const { t } = useLang();
    const items = t.home.marquee;
    const Row = ({ hidden = false }) => (
        <div className="flex shrink-0 items-center" aria-hidden={hidden}>
            {items.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="whitespace-nowrap px-6 font-serif text-xl italic text-gold-700 md:text-2xl">{item}</span>
                    <span className="h-1.5 w-1.5 rounded-full bg-peri-400" aria-hidden="true" />
                </span>
            ))}
        </div>
    );
    return (
        <div className="overflow-hidden border-y border-peri-200 bg-peri-50 py-5" data-testid="brand-marquee">
            <div className="marquee-track">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
